<template>
    <div style="width: 1200px; height: 680px; border-radius: 12px; background: #4C9FF2; position: relative;">
        <!--顶部-->
        <div style="width: 100%; height: 120px; display: flex; border-top-left-radius: 12px; border-top-right-radius: 12px;">
            <div style="width: 420px; height: 100%; border-top-left-radius: 12px;" class="come">
                <div class="vip" style="width: 120px; height: 116px; position: relative; display: flex; justify-content: center; align-items: center; border-top-left-radius: 12px;">
                    <div style="width: 160px;line-height: 20px;margin-top: -40px;color: #FFFFFF;font-size: 20px;font-weight: 500;margin-left: 25px;">确认订单</div>
                </div>
            </div>
            <div style="width: 420px; height: 120px; margin-left: 360px;border-radius: 8px;">
                <div class="bgRight" style="width: 100%; height: 120px;border-radius: 8px;">
                    <div @click="onClose" style="width: 24px;height: 24px;float: right;margin-top: 15px;margin-right: 15px;cursor: pointer;">
                        <svg class="close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.31891 6.31879C6.54302 6.09467 6.90639 6.09467 7.13051 6.31879L12.0001 11.1884L16.8697 6.31879C17.0938 6.09467 17.4572 6.09467 17.6813 6.31879C17.9054 6.54291 17.9054 6.90627 17.6813 7.13039L12.8117 12L17.6813 16.8696C17.9054 17.0937 17.9054 17.4571 17.6813 17.6812C17.4572 17.9053 17.0938 17.9053 16.8697 17.6812L12.0001 12.8116L7.13051 17.6812C6.90639 17.9053 6.54302 17.9053 6.31891 17.6812C6.09479 17.4571 6.09479 17.0937 6.31891 16.8696L11.1885 12L6.31891 7.13039C6.09479 6.90627 6.09479 6.54291 6.31891 6.31879Z" fill="white"></path></svg>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 1120px; height: 560px; background: #FFFFFF; position: absolute; top: 60px; left: 40px;border-radius: 8px;">
            <div style="width: 130px;line-height: 25px;font-size: 16px;color: rgb(53, 68, 93);font-weight: 500;margin: 20px 0;">订单详情</div>
            <div style="width: 1050px;height: 306px;margin: 0 auto;">
                <div style="width: 100%;height: 90px;display: flex;justify-content: space-between;border-bottom: 1px solid rgb(232, 232, 232);">
                    <div style="width: 286px;height: 74px;display: flex;">
                        <div style="width: 48px;height: 48px;margin-top: 13px; background: rgb(22, 132, 252);line-height: 48px;font-size: 14px;font-weight: 500;text-align: center;border-radius: 8px;color: #FFFFFF;">企</div>
                        <div style="width: calc(100% - 48px);height: 100%;color: rgb(53, 68, 93);font-size: 16px;font-weight: 500;margin-left: 16px;text-align: left;">
                            <div style="line-height: 28px;margin-top: 12px;">{{user.nickName}}</div>
                            <div v-if="user.isVip > 0" style="font-size: 14px;color: rgb(93, 111, 143);">现有{{info.userSubConut}}协作席位，{{info.userSubEndTime}}到期</div>
                            <div v-else style="font-size: 14px;color: rgb(93, 111, 143);">暂无协作席位</div>
                        </div>
                    </div>
                    <div style="width: 320px;height: 74px;">
                        <div style="width: calc(100% - 48px);height: 100%;color:rgb(53, 68, 93);font-size: 14px;font-weight: 500;text-align: left;">
                            <div style="margin-top: 12px;display: flex;">
                                <div style="margin-right: 20px;color: rgb(93, 111, 143);">下单时间</div>
                                <div style="line-height: 22px;">{{info.createTime}}</div>
                            </div>
                            <div style="margin-top: 12px;display: flex;">
                                <div style="margin-right: 20px;color: rgb(93, 111, 143);">订单编号</div>
                                <div>{{info.orderNo}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;height: 216px;display: flex;">
                    <ul class="detailWrap">
                        <li>
                            <span class="left">方案名称</span>
                            <span class="right">{{info.title}}</span>
                        </li>
                        <li>
                            <span class="left">购买时长</span>
                            <span class="right">{{info.year}}</span>
                        </li>
                        <li>
                            <span class="left">方案到期时间</span>
                            <span class="right">支付成功日起 365 天</span>
                        </li>
                    </ul>
                    <div class="divideLine"></div>
                    <ul class="detailWrap">
                        <li>
                            <span class="left">订单总额</span>
                            <span class="right">￥{{utils.keepTwoDecimalFull(info.price)}}</span>
                        </li>
                        <li v-if="user.isVip == 0">
                            <span class="left">套餐空间</span>
                            <span class="right">{{info.bindSize}}GB</span>
                        </li>
                        <li v-if="info.subCount > 0">
                            <span class="left">席位数量</span>
                            <span class="right">{{info.subCount}}</span>
                        </li>
<!--                        <li v-else>-->
<!--                            <span class="left">超出容量</span>-->
<!--                            <span class="right">{{info.size}}GB</span>-->
<!--                        </li>-->
                        <li>
                            <span class="left">优惠卷</span>
                            <span class="right">-￥{{utils.keepTwoDecimalFull(info.couponPrice)}}</span>
                        </li>
                    </ul>
                </div>
                <div style="width: 100%;height: 180px;text-align: left;font-weight: 500;">
                    <div style="width: 100%;height: 25px;font-size: 16px;line-height: 25px;margin-bottom: 20px;color:rgb(53, 68, 93);">支付方式</div>
                    <div style="width: 100%;height: 135px;display: flex;justify-content: space-between;">
                        <div style="width:50%;height: 100%;">
                            <div style="width: 100%;height: 23px;display: flex;">
                                <div style="width: 32px;height: 16px;margin-right: 8px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="svg__StyledSvg-sc-5p68xx-0 gSyYMA svg-icon ext00/order/gateway/bankwire icon" viewBox="0 0 32 22" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M29.1806 0H2.82376C1.2641 0 -0.000244141 1.26435 -0.000244141 2.824V19.296C0.000197599 20.8553 1.26442 22.1192 2.82376 22.1192H29.1798C30.739 22.1192 32.003 20.8552 32.003 19.296V2.824C32.0034 2.07518 31.7062 1.35688 31.1769 0.827227C30.6475 0.297579 29.9294 0 29.1806 0ZM27.2974 17.8856H20.7086V14.5904H27.2974V17.8856ZM1.41256 8.472H30.5918H30.5926V4.7072H1.41256V8.472Z" fill="#0087F2"></path></svg>
                                </div>
                                <div style="width: calc(100% - 32px); height:23px;line-height: 23px;">对公支付</div>
                            </div>
                            <div style="width: 100%; margin-top: 12px;font-size: 14px;line-height: 28px;color: rgb(93, 111, 143);">
                                获取对公支付详细信息，支付完成后我们会尽快确认到账并开通服务
<!--                                {{qrImgUrl + '?sign=' + info.sign}}-->
                            </div>
                            <div @click="isCorpAccountWin = true" @mouseenter="isToPublic = true" @mouseleave="isToPublic = false" :style="isToPublic == true ? 'background: #E8F3FF' : ''" style="width: 110px;height: 32px;border: 1px solid rgb(208, 230, 254);line-height: 32px;text-align: center;border-radius: 6px;margin-top: 20px;cursor: pointer;background: rgb(245, 248, 253);color: rgb(93, 111, 143);">
                                我要对公支付
                            </div>
                        </div>
                        <div style="width:50%;height: 100%;">
                            <div style="width: 476px;height: 135px;margin-left: calc(100% - 496px);display: flex;">
                                <div style="width: 140px;height: 140px;">
                                    <vue-qr
                                        :text="qrImgUrl + '?sign=' + info.sign"
                                        :size="140"
                                        :logoScale="0.5">
                                    </vue-qr>
                                </div>
                                <div style="width: calc(100% - 140px);height: 112px;margin-top: 12px;">
                                    <div style="width: 302px;height: 32px;display: flex;">
                                        <div style="line-height: 45px;display: inline-block; color: rgb(53, 68, 93);">应付金额</div>
                                        <span style="margin-left: 12px;color: red;font-size: 14px;line-height: 20px;">¥
                                        <span style="font-size: 28px;font-weight: 700;line-height: 32px;">{{utils.keepTwoDecimalFull(info.price)}}</span></span>
                                    </div>
                                    <div style="width: 302px;height: 24px;margin-top: 15px;display:flex;color: rgb(93, 111, 143);">
                                        <div style="width: 24px;height: 24px;margin-right: 6px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="svg__StyledSvg-sc-5p68xx-0 gSyYMA svg-icon ext00/order/gateway/wxpay icon" viewBox="0 0 24 24" aria-hidden="true"><g><rect width="24" height="24" rx="6" fill="#40BA49"></rect><path d="M17.3201 13.4797C17.5121 13.4771 17.6955 13.3998 17.8312 13.264C17.967 13.1283 18.0443 12.9449 18.0468 12.7529C18.0468 12.3499 17.7239 12.0262 17.3201 12.0262C16.9163 12.0262 16.5934 12.3499 16.5934 12.7529C16.5934 13.1576 16.9171 13.4797 17.3201 13.4797ZM13.7391 13.4797C13.931 13.4771 14.1144 13.3998 14.2502 13.264C14.3859 13.1283 14.4633 12.9449 14.4658 12.7529C14.4658 12.3499 14.1421 12.0262 13.7391 12.0262C13.3344 12.0262 13.0124 12.3499 13.0124 12.7529C13.0124 13.1576 13.3353 13.4797 13.7391 13.4797ZM19.0536 17.5584C19.0017 17.5872 18.9603 17.6317 18.9353 17.6855C18.9103 17.7393 18.903 17.7996 18.9144 17.8578C18.9144 17.8967 18.9144 17.9363 18.9346 17.9768C19.0139 18.3143 19.1726 18.8516 19.1726 18.8719C19.1726 18.9309 19.1928 18.9706 19.1928 19.0111C19.1928 19.0345 19.1882 19.0577 19.1792 19.0794C19.1702 19.101 19.157 19.1207 19.1403 19.1372C19.1237 19.1538 19.104 19.1669 19.0823 19.1758C19.0606 19.1847 19.0374 19.1892 19.0139 19.1891C18.9735 19.1891 18.954 19.1697 18.9144 19.1502L17.7418 18.4737C17.6561 18.4266 17.561 18.3994 17.4634 18.3944C17.4043 18.3944 17.3444 18.3944 17.3047 18.4138C16.748 18.5732 16.1718 18.6525 15.5559 18.6525C12.594 18.6525 10.209 16.6642 10.209 14.1975C10.209 11.7316 12.594 9.74243 15.5559 9.74243C18.517 9.74243 20.902 11.7316 20.902 14.1975C20.902 15.5304 20.1866 16.7435 19.0536 17.5592V17.5584ZM15.7817 8.93801C15.7062 8.9355 15.6306 8.93415 15.5551 8.93397C12.1772 8.93397 9.39975 11.2485 9.39975 14.1983C9.39975 14.6466 9.46449 15.0804 9.58427 15.4931H9.51224C8.80514 15.486 8.10205 15.3859 7.42107 15.1953C7.36119 15.1751 7.3013 15.1751 7.24142 15.1751C7.12182 15.1776 7.00505 15.212 6.90314 15.2746L5.48853 16.088C5.44806 16.1082 5.40841 16.1284 5.36875 16.1284C5.311 16.1278 5.25579 16.1046 5.21495 16.0637C5.17411 16.0229 5.15088 15.9677 5.15025 15.9099C5.15025 15.85 5.16967 15.8104 5.18991 15.7505C5.20933 15.7311 5.38899 15.0756 5.48853 14.679C5.48853 14.6385 5.50795 14.5795 5.50795 14.5398C5.50773 14.4704 5.49147 14.4021 5.46045 14.34C5.42942 14.2779 5.38447 14.2239 5.3291 14.1821C3.95414 13.2086 3.09793 11.76 3.09793 10.1511C3.09793 7.19484 5.98704 4.81152 9.53166 4.81152C12.5786 4.81152 15.1399 6.56684 15.7817 8.9372V8.93801ZM11.6107 9.27629C12.0744 9.27629 12.441 8.89027 12.441 8.44598C12.441 7.98226 12.0744 7.61566 11.6107 7.61566C11.147 7.61566 10.7804 7.98226 10.7804 8.44598C10.7804 8.90969 11.147 9.27629 11.6107 9.27629ZM7.35391 9.27629C7.81762 9.27629 8.18503 8.89027 8.18503 8.44598C8.18503 7.98226 7.81762 7.61566 7.35391 7.61566C6.891 7.61566 6.52359 7.98226 6.52359 8.44598C6.52359 8.90969 6.891 9.27629 7.35391 9.27629Z" fill="white"></path></g></svg>
                                        </div>
                                        <div style="width: 24px;height: 24px;margin-right: 6px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="svg__StyledSvg-sc-5p68xx-0 gSyYMA svg-icon ext00/order/gateway/alipay icon" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.001 4.61454V16.4297C24.001 16.4297 17.5299 14.4513 16.1082 13.9367C16.9635 12.467 17.646 10.7842 18.0962 8.9526H13.2014V7.29379H19.2011V6.27623H13.2014V3.50674H10.8936C10.4799 3.50674 10.429 3.88112 10.429 3.88112V6.27719H4.80077V7.29475H10.4281V8.95356H5.81449V9.87801H15.1396C14.7968 11.0453 14.3447 12.1445 13.8004 13.1409C13.5469 13.0572 13.3069 12.9766 13.0761 12.8992C11.3931 12.3341 10.2065 11.9358 7.93888 11.7231C3.045 11.2623 1.91896 13.9482 1.74329 15.5907C1.47738 18.0924 3.69297 20.1371 7.01252 20.1371C10.3321 20.1371 12.5342 18.6089 14.6375 16.0611C17.295 17.3294 22.301 19.4959 23.7701 20.1317C23.8288 20.1571 23.8819 20.1801 23.929 20.2005C23.544 22.3585 21.6558 24 19.3855 24H4.61453C2.06584 24 0 21.9322 0 19.3855V4.61454C0 2.0668 2.06776 0 4.61453 0H19.3845C21.9332 0 24.001 2.06776 24.001 4.61454ZM3.30924 15.5809C3.123 16.5064 3.67788 18.7211 7.18572 18.7211C9.34572 18.7211 11.4251 17.4088 13.1176 15.2037C10.708 14.0325 8.7006 13.4574 6.45996 13.4574C4.50924 13.4574 3.49356 14.6603 3.30924 15.5809Z" fill="#00A0E9"></path></svg>
                                        </div>
                                        <div style="width: 132px;line-height: 24px;color: rgb(93, 111, 143);font-size: 14px;font-weight: normal;font-weight: 500">
                                            支持微信/支付宝扫码
                                        </div>
                                    </div>
                                    <div style="width: 302px;height: 20px;margin-top: 15px;display:flex;color: rgb(93, 111, 143);">
                                        <div style="width: 250px;line-height: 20px;color: rgb(93, 111, 143);font-size: 14px;font-weight: normal;font-weight: 500">
                                            1抓紧时间支付，否则订单将自动取消
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-container">
            <el-dialog :visible.sync="isCorpAccountWin" width="1200px" custom-class="login-dialog" class="custom-dialog">
                <corp-account-win :info="info" :onClose="function (){isCorpAccountWin = false}" />
            </el-dialog>
        </div>

        <div class="dialog-container">
            <el-dialog :visible.sync="isPaySuccess" width="1200px" custom-class="login-dialog" class="custom-dialog" :close-on-click-modal="false">
                <pay-success-win  />
            </el-dialog>
        </div>
    </div>
</template>

<script>
import corpAccountWin from "./corpAccountWin.vue";
import paySuccessWin from "../paySuccessWin.vue";
export default {
    components: {corpAccountWin,paySuccessWin},
    props:{
        onClose:{
            type:Function,
            default(){}
        },
        info:{
            type: Object,
            default() {}
        }
    },
    computed:{
        user(){
            return this.$store.state.user;
        },
    },
    data() {
        return {
            isToPublic:false,
            isCorpAccountWin:false,
            isPaySuccess:false,
            qrImgUrl:this.$store.state.mobileUrl,
            //定时器
            intervalId: null
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId); // 组件销毁时清除定时器
    },
    mounted() {
        //轮询支付结果
        //this.intervalId = setInterval(this.pollingQuery, 3000);
    },
    methods:{
        //这里进行轮询查询是否支付成功 每3秒查询一次
        pollingQuery(){
            var that = this;
            that.newApi.getPrePayOrder({sign:that.info.sign}).then((res)=>{
                if(res.isSuccess == -1){
                    // -2未查询到预支付订单信息 -3订单已支付
                    if(res.data.code == -3){
                        that.isPaySuccess = true;
                        clearInterval(that.intervalId); // 结束轮询
                    }
                }
            })
        },
    }
};
</script>

<style scoped>
.come{
    background-image: url('../../../../../assets/imgs/vip/header_left.png');
    background-size: 100% 100%;
}
.vip{
    background-image: url('../../../../../assets/imgs/vip/header_diamond_success.png');
    background-size: 100% 100%;
}
.el-dialog__header{
    padding: 0px;
}
.el-dialog__body {
    padding: 0px;
}
.bgRight{
    background-image: url('../../../../../assets/imgs/vip/header_right_success.png');
    background-size: 100% 100%;
}
.detailWrap{
    width: 417px;height: 128px;padding: 36px 0px;
}
ul{
    list-style: none;
}

.detailWrap li {
    width: 100%;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
}
.detailWrap li .left{
    color: rgb(93, 111, 143);
}
.detailWrap li .right{
    color: rgb(53, 68, 93);
    line-height: 14px;
}

.divideLine {
    width: 1px;
    height: 200px;
    background-color: rgb(232, 232, 232);
    margin: 0px 100px;
}
</style>

<script setup>
import VueQr from "_vue-qr@2.5.0@vue-qr";
import {getYear} from "../../../../../utils/utils";
</script>
